/**
 * This file hosts all client types used ONLY as part of the client session protocol
 * and is not shared with the server session protocol.
 */
/**
 * Indicates the state of server authentication. The state is authenticated when a token provision response is received.
 * @codegen
 */
export var ServerAuthenticationState;
(function (ServerAuthenticationState) {
    ServerAuthenticationState[ServerAuthenticationState["NotAuthenticated"] = 0] = "NotAuthenticated";
    ServerAuthenticationState[ServerAuthenticationState["Pending"] = 1] = "Pending";
    ServerAuthenticationState[ServerAuthenticationState["Authenticated"] = 2] = "Authenticated";
    ServerAuthenticationState[ServerAuthenticationState["WacUserInfoAuthenticated"] = 3] = "WacUserInfoAuthenticated";
})(ServerAuthenticationState || (ServerAuthenticationState = {}));
//# sourceMappingURL=client-protocol.js.map